const images = [
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/1.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/1.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/0.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/0.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/1.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/1.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/2.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/2.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/3.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/3.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/4.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/4.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/5.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/5.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/6.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/6.svg',
  // },
  // {
  //   url: 'https://cdn.winwinapp.ru/static/images/interesants/7.svg',
  //   anUrl: 'https://cdn.winwinapp.ru/static/images/interesants/7.svg',
  // },
  {
    url: 'https://io.winwinapp.ru/images/Prof.png',
    anUrl: 'https://io.winwinapp.ru/images/Prof.png',
  },
]

// export default () => images[Math.round(Math.random() * 8)]
export default () => images[0]
